module.exports = __webpack_public_path__ + "media/categories/303-ed859f8d.svg";